import { http } from '@pendo/http';
import { PendoNotification } from '@pendo/components-vue3';

async function getInsightsJob (body) {
    return http
        .post('/api/s/_SID_/insights/summary?job=true', body)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

async function getInsightsJobStatus (jobId) {
    const { status } = await http
        .get(`/api/s/_SID_/insights/summary/status/${jobId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });

    if (status === 'RUNNING') {
        return new Promise((resolve) => {
            setTimeout(async () => {
                const result = await getInsightsJobStatus(jobId);
                resolve(result);
            }, 15000);
        });
    }

    return status;
}

export async function getUserInsights (responseBody) {
    const insightsJob = await getInsightsJob(responseBody);
    const { jobId } = insightsJob;

    if (jobId) {
        const status = await getInsightsJobStatus(jobId);

        if (status === 'DONE') {
            return getInsightsJob(responseBody);
        }

        if (status === 'FAILED') {
            throw new Error('Insights job failed');
        }
        throw new Error('Unexpected job status');
    } else {
        return insightsJob;
    }
}

export function CustomNotification (config) {
    const instance = PendoNotification(config);

    requestAnimationFrame(() => {
        const el = instance?.$el;
        if (!el) return;
        el.style.cursor = 'pointer';
        instance?.$el?.addEventListener('click', (evt) => {
            config?.onClick?.(evt);
            instance?.close();
        });
    });

    return instance;
}

export function processStarsAndHistoryForContext (item, body = {}, include = []) {
    const { id, type, appId } = item;
    if (!type) return;

    const firstLetter = type.charAt(0).toLowerCase();
    const propType = firstLetter + type.slice(1);
    if (!include.includes(propType)) {
        return;
    }

    if (body[propType]) {
        body[propType].push({ id, appId });
    } else {
        body[propType] = [{ id, appId }];
    }
}

export function convertGeneratedInsightToMarkdown (generatedInsight) {
    const { title, context, insightBreakdown, whyThisMatters, ideasToTest } = generatedInsight;

    const insightBreakdownMarkdownMap = insightBreakdown.map((section) => {
        return `### ${section.header}\n${section.breakdown}`;
    });

    const ideasToTestMarkdownMap = ideasToTest.map((idea) => {
        return `**${idea.idea}**  \n${idea.explanation}`;
    });

    const markdownInsight = `Here's more information about this insight:

---

# ${title}

>💡 **Takeaway**: ${context}

${insightBreakdownMarkdownMap.join('\n\n')}

### Why this matters
${whyThisMatters}

### Ideas to Test
${ideasToTestMarkdownMap.join('\n\n')}`;

    return markdownInsight;
}
